// extracted by mini-css-extract-plugin
export var error = "_6Ck9s";
export var info = "ptJO-";
export var main = "ZoerS";
export var message = "_5ahMx";